
// Request animation frame
var raf = window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame;

var $body,
    $window,
    $toggleMenu,
    $menus,
    $header,
    $wordsTopbar,
    $topbarOffset,
    $faqAnswers,
    $faqQuestions,
    currentScroll = 0,
    lastScrollTop = 0,
    $reviewSliders,
    $share,
    $showMore,
    $content,
    $eventToggle,
    $courseHeader,
    $courseMenu,
    $teacher,
    $teacherBio,
    $passsToggle,
    $toggleFilter,
    $filter,
    $tabLinks,
    $tabs,
    $printButton,
    $printContents,
    $eventData,
    $selectEvent,
    $scrollDown,
    $downloadList,
    $printButtonEvent,
    $printButtonStudents,
    $printContentsEvent,
    $printContentsStudent;

//add filter before document ready




$(document).ready(function($) {

    console.log('%cLinku Novio', "font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body          = $('body');
    $window        = $(window);
    $toggleMenu    = $('.js-toggle-menu');
    $menus         = $('.js-menu--main, .js-menu--account, .js-menu--accountloggedin');
    $header        = $('.js-header');
    $reviewSliders = $('.js-review-slider');
    $share         = $('.js-share');
    $showMore      = $('.js-show-more');
    $content       = $('.js-content');
    $eventToggle   = $('.js-toggle-event');
    $courseMenu    = $('.js-course-menu');
    $courseHeader  = $('.js-course-header');
    $wordsTopbar   = $('.js-words-topbar');
    $topbarOffset  = $wordsTopbar.offset();
    $faqQuestions  = $('.js-faq-question');
    $faqAnswers    = $('.js-faq-answer');
    $teacher       = $('.js-teacher');
    $teacherBio    = $('.js-teacher-bio');
    $passsToggle   = $('.js-pw-toggle');
    $toggleFilter  = $('.js-filter-toggle');
    $filter        = $('.js-filter');
    $tabLinks      = $('.js-tab-link');
    $tabs          = $('.js-tabs');
    $selectEvent   = $('.js-event-select');
    $downloadList  = $('.js-download-toggle');
    $printButtonEvent   = $('.js-print-event-button');
    $printButtonStudents   = $('.js-print-students-button');
    $printContentsEvent = $('.js-print-contents-event');
    $printContentsStudent = $('.js-print-contents-student');
    $eventData     = $('.js-event-data').data('event');
    $scrollDown = $('.js-scroll-down');

    // Close open menu when clicking outside dropdown
    $body.on('click', function (e) {
        $toggleMenu.removeClass('is-open');
        $toggleMenu.next().removeClass('is-open');
        $share.removeClass('is-open');
    });

    $scrollDown.on('click', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $(target)[0].scrollIntoView(
          { block: 'start',  behavior: 'smooth' }
        );
    });


    $eventToggle.on('click', function(e) {
        // Dont toggle when link inside element is clicked
        if ($(e.target).is('a')) {
            return;
        }
        $(this).toggleClass('is-open');
        $(this).siblings('.js-days').slideToggle();
    });

    $tabLinks.on('click', function(e) {
        var target_index = $(this).data('tab-index');
        var $target = $('.js-tab-' + target_index);

        $tabLinks.removeClass('is-current');
        $(this).addClass('is-current');

        $tabs.removeClass('is-active');
        $target.addClass('is-active');
    });

    $selectEvent.on('change', function(){
       var val = $(this).val();
        $selectEvent.val(val);
    });


    $passsToggle.on('click', function(){
        var input = $(this).prev();

        if (input.attr('type') === 'password') {
            input.attr('type', 'text')
        } else {
            input.attr('type', 'password')
        }
    });

    $share.on('click', function(e) {
        e.stopPropagation();
        $share.addClass('is-open');
    });

    $downloadList.on('click', function(e){
       $(this).next().slideToggle();
    });

    $showMore.on('click', function(e) {
        e.preventDefault();
        $content.toggleClass('is-open');

        if ($content.hasClass('is-open')) {

            var newHeight = $content.children(":first").height();

            $content.height(newHeight);
        } else {

            $content.height('');
        }
    });

    $reviewSliders.each(function (index, value) {
        tns({
            container: value,
            mode: 'carousel',
            items: 900,
            mouseDrag: true,
            speed: 600,
            nav: false,
            gutter: 24,
            autoplayButtonOutput: false,
            controls: true,
            controlsText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
            autoplay: false,
            autoHeight: false,
            autoplayHoverPause: true,
            rewind: true,
            responsive: {
                768: {
                    items: 3
                }
            }
        });
    });

    // Cancel closing window, and toggle menu
    $toggleMenu.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!$(this).hasClass('is-open')) {
            $toggleMenu.removeClass('is-open');
            $toggleMenu.next().removeClass('is-open');
        }

        $(this).toggleClass('is-open');
        $(this).next().toggleClass('is-open');
    });

    $faqQuestions.on('click', function () {
        if ($(this).hasClass('is-open')) {
            $faqAnswers.slideUp();
            $faqQuestions.removeClass('is-open');
        } else {
            $faqAnswers.slideUp();
            $faqQuestions.removeClass('is-open');
            $(this).next().slideToggle('fast');
            $(this).addClass('is-open');
        }
    });

    $teacher.on('click', function () {
        if ($(this).hasClass('is-open')) {
            $teacherBio.slideUp();
            $teacher.removeClass('is-open');
        } else {
            $teacherBio.slideUp();
            $teacher.removeClass('is-open');
            $(this).next().slideToggle('fast');
            $(this).addClass('is-open');
        }
    });


    // Scroll check functions functions
    if (raf) {
        loop();
    }

    function scroll()  {
        currentScroll = $window.scrollTop();

        if (currentScroll < 20) {
            $header.addClass('is-at-top');
        } else {
            $header.removeClass('is-at-top');
        }

        if($wordsTopbar.length  !== 0){
            setWordsTopbar();
        }

        if ($courseHeader.length > 0 && $courseMenu.length > 0 ) {
            if(!$courseHeader.isInViewport()) {
                $courseMenu.addClass('is-open')
            } else {
                $courseMenu.removeClass('is-open')
            }

        }
    }

    function loop() {
        var scrollTop = $window.scrollTop();
        if (lastScrollTop === scrollTop) {
            raf(loop);
        } else {
            lastScrollTop = scrollTop;

            // fire scroll function if scrolls vertically
            scroll();

            raf(loop);
        }
    }

    function setWordsTopbar() {
        currentScroll = $window.scrollTop();
        if ($topbarOffset.top - 75 <= currentScroll) {
            $wordsTopbar.addClass('sticky');
        } else {
            $wordsTopbar.removeClass('sticky');
        }

    }

    $printButtonEvent.on('click', function (e) {
        var printdata = '<div class="c-portal-event__print"><h4>'+ $eventData + '</h4>';
        var originalContent = document.body.innerHTML;
        printdata = printdata + $printContentsEvent[0].innerHTML + '</div>';
        document.body.innerHTML = printdata;
        window.print();
        document.body.innerHTML = originalContent;
    });
    $printButtonStudents.on('click', function (e) {
        var printdata = '<div class="c-portal-event__print"><h2>Cursisten</h2><h4>'+ $eventData + '</h4>';
        var originalContent = document.body.innerHTML;
        printdata = printdata + $printContentsStudent[0].innerHTML  + '</div>';
        document.body.innerHTML = printdata;
        window.print();
        document.body.innerHTML = originalContent;
    });

    window.onafterprint = function(){
        window.location.reload(true);
    }

});


$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
